import { render, staticRenderFns } from "./PosterCreate.vue?vue&type=template&id=d71aefc6&"
import script from "./PosterCreate.vue?vue&type=script&lang=js&"
export * from "./PosterCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports